<template>
  <div class="body">

    <!-- 筛选 -->
    <div class="search">
      <div class="tabs">
        <el-tabs v-model="datas.filter_fba" type="card" @tab-click="search">
          <!-- 全部 -->
          <el-tab-pane :label="$t('message.all') + `(${tabs[0].num})`" name=""></el-tab-pane>
          <!-- 紧急 -->
          <el-tab-pane :label="$t('message.overdue')" name="overdue"></el-tab-pane>
          <!-- 普通配送单 -->
          <el-tab-pane :label="$t('message.generalDistributionList') + `(${tabs[1].num})`" name="1"></el-tab-pane>
          <!-- FBA配送单 -->
          <el-tab-pane :label="$t('message.fBADeliveryOrder') + `(${tabs[2].num})`" name="2"></el-tab-pane>
          <!-- 提出时间90天 -->
          <el-tab-pane :label="$t('message.submissionTime90Days')" name="3" v-if="status == 30"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="operationContainer">
        <div class="leftContainer">
          <!-- 开始日期-->
          <div class="item">
            <el-date-picker v-model="datas.dateStart" :placeholder="$t('message.startDate')" class="Container"
              type="datetime" default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss" style="width: 180px">
            </el-date-picker>
          </div>
          <!--  结束日期-->
          <div class="item">
            <el-date-picker v-model="datas.dateEnd" :placeholder="$t('message.dateClosed')" class="Container"
              default-time="['23:59:59']" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 180px">
            </el-date-picker>
          </div>
          <!-- 客户ID-->
          <div class="item">
            <el-input v-model="datas.user_id" :placeholder="$t('message.pleaseEnterID')" class="Container"
              onfocus="this.select()" />
          </div>
          <!--   请输入配送单号-->
          <div class="item">
            <el-input v-model="datas.porder_sn" :placeholder="$t('message.pleaseEnterTheShippingNumber')"
              class="Container" onfocus="this.select()" />
          </div>
          <!--   请输入订单号-->
          <div class="item">
            <el-input v-model="datas.order_sn" :placeholder="$t('message.pleaseEnterTheOrderNumber')" class="Container"
              onfocus="this.select()" />
          </div>
          <!--   请输入物流号号-->
          <div class="item" v-if="status == 60">
            <el-input v-model="datas.express_no" :placeholder="$t('message.logisticsNumber')" class="Container"
              onfocus="this.select()" />
          </div>
          <!--  发送方式选择-->
          <div class="item" v-if="status == 60 || status == 50">
            <el-select v-model="datas.logistics_id" :placeholder="$t('message.sendingModeSelection')" filterable
              clearable>
              <el-option v-for="item in logisticsList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!--  发票状态-->
          <div class="item" v-if="status == 60">
            <el-select v-model="datas.filter_invoice" :placeholder="$t('message.invoiceStatus')" filterable clearable>
              <el-option v-for="item in invoiceStatus" :key="item.value" :label="item.value" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <!--  唛头状态-->
          <div class="item" v-if="status == 60">
            <el-select v-model="datas.filter_maitou_print" :placeholder="$t('message.shippingMarkStatus')" filterable
              clearable>
              <el-option v-for="item in shippingMarkStatus" :key="item.value" :label="item.value" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <!--人员范围-->
          <div class="item">
            <!--  人员范围-->
            <cascader @setUserList="setUserList" :org_id="datas.org_id" ref="cascader" />
          </div>
          <!--  全部人员-->
          <div class="item">
            <el-select v-model="datas.admin_id" :placeholder="$t('message.allPersonnel')" filterable clearable>
              <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 采购 -->
          <div class="item">
            <el-select v-model="datas.g_id" clearable filterable :placeholder="$t('message.buyer')">
              <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 业务 -->
          <div class="item">
            <el-select v-model="datas.y_id" clearable filterable :placeholder="$t('message.salesman')">
              <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 配货员 -->
          <div class="item">
            <el-select v-model="datas.p_id" clearable filterable :placeholder="$t('message.distributionMember')">
              <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 客戶屬性 -->
          <div class="item">
            <el-select v-model="datas.attribute" clearable filterable placeholder="SVIP">
              <el-option :label="item.label" :value="item.value" v-for="(item) in vipList" :key="item.value">
              </el-option>
            </el-select>
          </div>
          <!-- (装箱授权) -->
          <div class="item">
            <el-select v-model="datas.authorized" clearable filterable :placeholder="$t('message.authorizationStatus')">
              <el-option :label="item.label" :value="item.value" v-for="(item) in authorized" :key="item.value">
              </el-option>
            </el-select>
          </div>
          <!-- 提出 -->
          <div class="item">
            <el-select v-model="datas.filter_created_by_type" clearable filterable
              :placeholder="$t('message.putForward')">
              <el-option label="业务提出" value="admin">
              </el-option>
              <el-option label="客户提出" value="user">
              </el-option>
            </el-select>
          </div>
          <div class="item">
            <!--  搜索 -->
            <el-button type="primary" @click="search">{{
              $t("message.search")
            }}</el-button>
            <!--  重置 -->
            <el-button @click="reset">{{ $t("message.reset") }}</el-button>
          </div>
        </div>
      </div>
      <div class="btn" v-if="status == 20">
        <!-- 订单展开或者收起 -->
        <el-button type="success" @click="isMaxHeight = !isMaxHeight">{{ isMaxHeight ? $t('message.orderExpand') :
          $t('message.orderCollapse') }}</el-button>
        <!-- 删除订单 -->
        <el-button type="primary" @click="deliveryOrderDeletion" v-if="isAuth(477)">{{
          $t("message.deliveryOrderDeletion")
        }}</el-button>
        <!-- 调整操作员 -->
        <el-button type="success" @click="allot" v-if="isAuth(221)">{{
          $t("message.adjustTheOperator")
        }}</el-button>
        <!-- 配送单合并 -->
        <el-button type="primary" @click="isPorderAddressSame" v-if="isAuth(223)">{{
          $t("message.consolidationOfDistributionOrder")
        }}</el-button>
        <!--  标识贴标-->
        <el-button type="primary" class="primary" @click="addFbaSign" v-if="isAuth(227)">{{
          $t("message.markingAndLabeling")
        }}</el-button>

      </div>
      <!-- 订单展开或者收起 -->
      <div class="btn" v-else>
        <el-button type="success" @click="isMaxHeight = !isMaxHeight">{{ isMaxHeight ? $t('message.orderExpand') :
          $t('message.orderCollapse') }}</el-button>
        <!-- 调整操作员 -->
        <el-button type="primary" @click="allot" class="primary" v-if="isAuth(221)">{{
          $t("message.adjustTheOperator")
        }}</el-button>
      </div>
    </div>
    <!-- 列表 -->
    <div class="tableList">
      <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
        :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" ref="multipleTable"
        @cell-click="labelSelection" size="mini" v-if="show" :row-class-name="tableRowClassName">
        <el-table-column align="center" label="NO" prop="rowNumber" width="60">
        </el-table-column>
        <!-- 选择 -->
        <el-table-column width="45" align="center">
          <template slot="header" slot-scope="scope">
            <el-popover placement="right" title="合计" width="200" trigger="focus">
              <statistics :selectList="selectList" />
              <el-checkbox v-model="checked" @change="allChecked" slot="reference"></el-checkbox>
            </el-popover>
          </template>
          <template slot-scope="scope">
            <el-popover placement="right" title="合计" width="200" trigger="focus">
              <statistics :selectList="selectList" />
              <el-checkbox v-model="scope.row.checked" @change="handleSelectionChange" slot="reference"></el-checkbox>
            </el-popover>
          </template>
        </el-table-column>
        <!--  配送提出时间-->
        <el-table-column align="center" :label="$t('message.deliveryTimeOfPresentation')" prop="created_at" width="76">
        </el-table-column>
        <!--    翻译完了时间 -->
        <el-table-column align="center" :label="$t('message.translationTime')"
          prop="porder_time_node.datetime_translate" width="76" v-if="status == 21">
        </el-table-column>
        <!--    装箱完了时间 -->
        <el-table-column align="center" :label="$t('message.timeOfPackingFinished')"
          prop="porder_time_node.datetime_confirm" width="76" v-if="status == 22">
        </el-table-column>
        <!--    业务报价时间 -->
        <el-table-column align="center" :label="$t('message.businessQuotationTime')"
          prop="porder_time_node.datetime_offer" width="76" v-if="status == 30">
        </el-table-column>
        <!--    提交入金时间 -->
        <el-table-column align="center" :label="$t('message.timeToSubmitDeposit')"
          prop="porder_time_node.datetime_pay_submit" width="76" v-if="status == 40">
        </el-table-column>
        <!--    确认入金时间 -->
        <el-table-column align="center" :label="$t('message.confirmDepositTime')"
          prop="porder_time_node.datetime_pay_confirm" width="76" v-if="status > 40">
        </el-table-column>
        <!--    出货时间 -->
        <el-table-column align="center" :label="$t('message.shippingTime')" prop="porder_time_node.datetime_delivery"
          width="76" v-if="status == 60">
        </el-table-column>
        <!--  修改状态-->
        <el-table-column align="center" :label="$t('message.modifyTheStatus')" width="80" prop="created_type"
          v-if="status < 30 || status == '配送单待支付'">
          <template slot-scope="scope">
            <p>{{ scope.row.created_type }}</p>
          </template>
        </el-table-column>
        <!--  配送单类别-->
        <el-table-column align="center" :label="$t('message.porderType')" width="70" prop="merge_type">
          <template slot-scope="scope">
            <span v-if="scope.row.is_fba == 1" class="is_fba">贴标</span>
            <span v-else>普通配送单</span>
            <p v-for="(item, index) in scope.row.porder_fba_type" :key="index" style="color:#b4272d;font-size: 16px;">
              {{ item.type }}
            </p>
            <!-- 亚马逊标识 -->
            <img src="@/assets/img/Amazon.png" alt="" style="width: 80px;" v-if="scope.row.is_amazon">
            <!-- STOCKCREW仓库配送单标识。 -->
            <img class="stockcrew-logo" src="@/assets/img/sc.svg" alt="STOCKCREW"
              v-if="scope.row.external_inbound && scope.row.external_inbound.warehouse_type === 'stockcrew'">

          </template>
        </el-table-column>
        <!--  客户属性-->
        <el-table-column align="center" :label="$t('message.customerProperty')" width="80">
          <template slot-scope="scope">
            <attributeName :name="scope.row.user_attribute" />
            <p v-if="scope.row.created_by_admin == null">
              <el-tooltip class="item" effect="dark" :content="scope.row.user.realname" placement="right">
                <span class="name" style="color: #606266;">
                  客户
                </span>
              </el-tooltip>
            </p>
            <p v-else>
              <el-tooltip class="item" effect="dark" :content="scope.row.created_by_admin.realname" placement="right">
                <span class="name">
                  业务
                </span>
              </el-tooltip>
            </p>
            <span class="name" style="font-size: 14px;" v-if="scope.row.user.authorized">(装箱授权)</span>
            <span class="name" style="font-size: 14px;" v-if="scope.row.user.is_pay_authorized">(入金授权)</span>
          </template>
        </el-table-column>
        <!--  出货形式-->
        <el-table-column align="center" :label="$t('message.formOfShipment')" width="60">
          <template slot-scope="scope">
            <div class="is_from_direct_box" v-if="scope.row.is_from_direct_box">
              <el-tooltip effect="dark" content="该配送单由直接装箱的箱子直接生成。" placement="top">
                <span> 箱</span>
              </el-tooltip>
            </div>
            {{ scope.row.merge_type }}
          </template>
        </el-table-column>
        <!--  配送单号-->
        <el-table-column align="center" :label="$t('message.deliveryNoteNumber')" min-width="120">
          <template slot-scope="scope">
            <div class="template" style="font-size: 14px;">
              <p>
                <router-link
                  :to="'/user/basicInformation?userID=' + scope.row.user.id + '&encryption=' + $md5(scope.row.user.id + '')"
                  target="_blank" style="color:#606266 ">
                  {{ scope.row.user.realname }}
                </router-link>
                <el-popover placement="top-start" trigger="hover" v-if="scope.row.children_user != null" title="子账号信息">
                  <p>{{ $t('message.names') }}:{{ scope.row.children_user.children_username }}</p>
                  <p>ID:{{ scope.row.children_user.id }}</p>
                  <img src="@/assets/user/children_user.png" alt="" slot="reference" style="vertical-align: middle;">
                </el-popover>
                <img src="@/assets/icon/illegal.png" alt="" slot="reference"
                  style="vertical-align: middle; width: 30px;" v-if="scope.row.user.user_tag != false">
              </p>
              <p>
              </p>
              <p class="oneself">
                <router-link :to="'/porderDetail?porder_sn=' + scope.row.porder_sn" target="_blank"
                  :style="{ color: scope.row.p_porder ? '#606266' : '' }">
                  <span v-if="scope.row.co_porder != false">总</span> {{ scope.row.porder_sn }}</router-link>
                <!-- 显示废弃 -->
                <span class="discard" v-if="scope.row.discard_status">废</span>
              </p>
              <!-- 商品标下载 -->
              <div v-if="datas.status == 20 && scope.row.is_amazon" class="downGoodsLabels">

                <a :href="baseURL + '/amazon.downGoodsLabels?porder_sn=' + scope.row.porder_sn"
                  rel="noopener noreferrer" target="_blank">
                  <el-button type="info" v-if="datas.status == 20 && scope.row.is_amazon">
                    {{ $t('message.productLabelDownload') }}

                  </el-button>
                </a>

              </div>
              <!-- 待出货的STOCKCREW并单子单不显示配送标下载。 -->
              <div class="downGoodsLabels"
                v-if="(datas.status == 60 || (datas.status == 50 && scope.row.merge_type !== '并单出货·子')) && scope.row.external_inbound && scope.row.external_inbound.warehouse_type === 'stockcrew'">
                <el-button type="info" @click="openOuterLabelDownload(scope.row.porder_sn)">
                  {{ $t('message.shippingLabelDownload') }}
                </el-button>
              </div>
              <div class="downGoodsLabels" v-if="datas.status == 50 && scope.row.is_amazon">
                <el-button type="info" @click="handleClick(scope.row)">
                  {{ $t('message.shippingLabelDownload') }}
                </el-button>
                <!-- 更新商品标图标  -->
                <i class="el-icon-refresh-left" v-if="scope.row.plan_reset && isAuth(704)"
                  @click="reGenerateInboundPlan(scope.row.porder_sn)"></i>
              </div>

              <!-- 计划名称 -->
              <p v-if="scope.row.plan_name" style="color:red;font-size:12px">
                {{ scope.row.plan_name }}
              </p>
              <!-- 装箱组名称 -->
              <p v-if="scope.row.shipment_name" style="color:red;font-size:12px">
                {{ scope.row.shipment_name }}
              </p>
              <div v-if="scope.row.p_porder">
                <p>
                  <router-link :to="'/porderDetail?porder_sn=' +
                    scope.row.p_porder_sn
                    " target="_blank">
                    父:{{ scope.row.p_porder_sn }}</router-link>
                </p>
              </div>
              <div v-if="scope.row.sub_porder">
                <p v-for="(item, index) in scope.row.sub_porder" :key="index">
                  <router-link :to="'/porderDetail?porder_sn=' + item.porder_sn" target="_blank"
                    style="color: #606266;">
                    子:{{ item.porder_sn }}</router-link>
                </p>
              </div>
              <div v-if="scope.row.co_porder">
                <p v-for="(item, index) in scope.row.co_porder" :key="index">
                  <router-link :to="'/porderDetail?porder_sn=' + item.porder_sn" target="_blank"
                    style="color: #606266;">
                    副:{{ item.porder_sn }}</router-link>
                </p>
              </div>
              <p v-if="scope.row.from_porder_sn">
                原: <router-link :to="'/porderDetail?porder_sn=' + scope.row.from_porder_sn" target="_blank"
                  style="color: rgba(180, 39, 45, 0.5);">
                  {{ scope.row.from_porder_sn }}
                </router-link>
              </p>
            </div>
          </template>
        </el-table-column>
        <!-- 标数 -->
        <el-table-column align="center" :label="$t('message.numberOfWords')" width="120" v-if="status == 21">
          <template slot-scope="scope">
            <!-- 预计贴标数 -->
            <p>{{ $t('message.expectedNumberOfLabels') }}:{{ scope.row.tag_num }}</p>
            <!-- 标签匹配数 -->
            <p>{{ $t('message.numberOfTagMatches') }}:{{ scope.row.tag_match_num }}</p>
          </template>
        </el-table-column>
        <!--  订单号-->
        <el-table-column align="center" :label="$t('message.orderNumber')" width="160">
          <template slot-scope="scope">
            <div class="orderList" :style="{ maxHeight: isMaxHeight ? '200px' : '10000px' }">
              <p v-for="(item, index) in scope.row.porder_detail" :key="index">
                <router-link :to="'/orderPaymentDetail?order_sn=' + item.order_sn" target="_blank">
                  {{ item.order_sn }}</router-link>
              </p>
            </div>
          </template>
        </el-table-column>
        <!--  番数-->
        <el-table-column align="center" :label="$t('message.numberOfWords')" width="80" prop="porder_detail_count"
          v-if="status < 60">
        </el-table-column>
        <!-- 发票品名编辑 -->
        <el-table-column align="center" :label="$t('message.invoiceItemNameEditing')" width="80" v-if="status == 50">
          <template slot-scope="scope">
            <router-link :to="'orderMaterialPreview?porder_sn=' + scope.row.porder_sn" class="a-link" target="_blank">
              {{ scope.row.has_invoice_count }} /
              {{ scope.row.should_invoice_count }}
            </router-link>
          </template>
        </el-table-column>
        <!--  发送方式-->
        <el-table-column align="center" :label="$t('message.wayToSend')" width="75">
          <template slot-scope="scope">
            <p>
              {{ $t("message.user") }}：
              {{ scope.row.logistics != null ? scope.row.logistics.name : '' }}
            </p>
          </template>
        </el-table-column>
        <!--  发送方式-->
        <el-table-column align="center" :label="$t('message.shippingMethods')" width="80" v-if="status == 50">
          <template slot-scope="scope">
            <div class="table">
              <ul v-for="(item, index) in scope.row.express_invoice" :key="index">
                <li>
                  <div>
                    {{ logisticsName(item.logistics_id) }}
                  </div>
                </li>
              </ul>
            </div>
          </template>
        </el-table-column>
        <!-- 物流单号状态 -->
        <el-table-column align="center" :label="$t('message.statusOfLogisticsOrderNumber')" v-if="status == 60"
          width="350">
          <template slot="header" slot-scope="scope">
            {{ $t('message.statusOfLogisticsOrderNumber') }}
            <p>
              <el-button size="mini" type="primary" @click="allPint"
                v-if="datas.logistics_id && datas.authorized != ''">
                批量打印唛头
              </el-button>
              <el-button size="mini" type="primary" @click="batchPint"
                v-if="datas.logistics_id == 1 || datas.logistics_id == 3">
                批量打印发票
              </el-button>
            </p>
          </template>
          <template slot-scope="scope" i>
            <div class="table">
              <ul v-for="(item, index) in scope.row.express_invoice" :key="index">
                <li>
                  <div>
                    {{ item.logistics_name }}
                    <div
                      v-if="item.logistics_name == 'KS-JP航空便' || item.logistics_name == 'KS-JP電子特殊便' || item.logistics_name == 'KS-JP航空経済便'">
                      <el-popover placement="bottom" title="物流信息" width="200" trigger="click">
                        <p v-if="findBOrderData.deliveryVendorShow">
                          物流公司:{{ findBOrderData.deliveryVendorShow }}
                        </p>
                        <p v-if="findBOrderData.deliveryVendorShow">
                          物流单号:{{ findBOrderData.deliveryNo }}
                        </p>
                        <p v-else>暂无物流信息</p>
                        <img src="@/assets/img/QS.png" alt="" style="height: 20px;" @click="findBOrder(item)"
                          slot="reference">
                      </el-popover>
                      <p>
                        <!--请求书 -->
                        <a :href="baseURL + '/porder.findTaxInfo?orderNo=' + item.express_no" target="_blank"
                          rel="noopener noreferrer">
                          <el-button type="text">请求书</el-button>
                        </a>
                      </p>
                    </div>
                    <p v-if="item.logistics_id == 1 || item.logistics_id == 3">
                      <el-button size="mini" :type="item.invoice_print_times > 0 ? 'success' : 'primary'"
                        @click="pintEMSinvoice(item, scope.$index, index)">
                        {{ item.invoice_print_times > 0 ? '已打印' : '打印发票' }}
                      </el-button>
                    </p>
                  </div>
                </li>
                <li class="flex2" v-if="item.logistics_name != 'コンテナ' && item.logistics_name != '海源 LCLコンテナ混載便'">
                  <!-- 国际物流 -->
                  <el-popover placement="left" width="400" trigger="click">
                    <p>{{ item.express_no }} <i class="el-icon-copy-document"
                        @click="copy(`${item.express_no}\n${activities != false ? activities[0].time : ''}\n${activities != false ? activities[0].address : ''}`)"></i>
                    </p>
                    <div v-if="activities != false" style="max-height: 600px; overflow-y: auto;">
                      <el-timeline>
                        <el-timeline-item v-for="(activity, index) in activities" :key="index"
                          :timestamp="activity.time" :color="activity.color" placement="top">
                          {{ activity.address }}
                        </el-timeline-item>
                      </el-timeline>
                    </div>
                    <p v-else> 暂无物流信息 </p>
                    <p slot="reference">
                      <img src="@/assets/img/user-img/trace.png" alt="" style="width: 20px;cursor: pointer;"
                        @click="lookExpress(item)">
                    </p>
                  </el-popover>
                  <router-link
                    :to="'/invoiceEdit?express_no=' + item.express_no + '&type=' + logisticsName(item.logistics_id)"
                    target="_blank">【编辑】{{ item.express_no
                    }}</router-link>
                  <!-- <a :href="baseURL + '/download.invoiceExcel?express_no=' +
                    item.express_no
                    " target="_blank" v-else>
                    {{ item.express_no }}
                  </a> -->
                  <!-- 超时标识 -->
                  <div class="timeout" v-if="item.logistics_status.timeout_status > 0">
                    超时{{ item.logistics_status.delivery_time - 12 }}天
                  </div>
                </li>
                <li v-else>
                  <a :href="baseURL + '/download.invoiceExcel?express_no=' + item.express_no" target="_blank">
                    {{ item.express_no }}
                  </a>
                </li>
                <li>
                  <div>
                    <router-link to="/">{{ item.box_count }}</router-link>箱
                    <p>
                      <el-button :type="item.maitou_print_at != '已打印' ? 'primary' : 'success'" size="mini"
                        @click="pint(item.express_no, item.logistics_name, scope.row.id, index)">
                        {{ item.maitou_print_at != '已打印' ? '打印' : item.maitou_print_at }}
                      </el-button>
                    </p>
                  </div>
                </li>
                <li>
                  <div>
                    {{ item.invoiceStatus }}
                    <p :style="{ color: item.maitou_print_at != '已打印' ? '#b4272d' : '' }">{{ item.maitou_print_at }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </template>
        </el-table-column>
        <!--  操作人员-->
        <el-table-column align="center" :label="$t('message.operatingPersonne')" width="100">
          <template slot-scope="scope">
            <div class="text-left">
              <!-- 业务 -->
              <p>
                {{ $t("message.business") }}：{{ scope.row.y_admin != null ? scope.row.y_admin.realname : '' }}
              </p>
              <!-- 配货 -->
              <p>
                {{ $t("message.distribution") }}：{{ scope.row.p_admin != null ? scope.row.p_admin.realname : '' }}
              </p>
              <!-- 采购 -->
              <p>{{ $t("message.purchase") }}：{{ scope.row.g_admin != null ? scope.row.g_admin.realname : '' }}</p>
              <!-- FBA -->
              <p>FBA：{{ scope.row.fba_admin != null ? scope.row.fba_admin.realname : '' }}</p>
              <p v-if="status == 60"> 出货:
                {{
                  scope.row.porder_time_node.delivery_by_admin ?
                    scope.row.porder_time_node.delivery_by_admin.realname : '' }}
              </p>
            </div>
          </template>
        </el-table-column>
        <!--  运费-->
        <el-table-column align="center" :label="$t('message.freight')" prop="logistics_price" v-if="status == 30">
        </el-table-column>
        <!--  商品金额-->
        <el-table-column align="center" :label="$t('message.goodsAmount')" prop="shipment_amount" v-if="status == 30">
        </el-table-column>
        <!--  业务配送单备注-->
        <el-table-column align="center" :label="$t('message.businessPorderRemark')" prop="porder_remark.y_remark">
          <template slot-scope="scope">
            <el-input type="textarea" v-model="scope.row.porder_remark.y_remark"
              v-if="isAuth(235) && roleStatus == 1 && status != 60"
              @blur="updateRemark(scope.row, scope.row.porder_remark.y_remark, 'y_remark')">
            </el-input>
            <span v-else>
              {{ scope.row.porder_remark.y_remark }}
            </span>
          </template>
        </el-table-column>
        <!--  配货配送单备注-->
        <el-table-column align="center" :label="$t('message.distributionPorderRemark')" prop="porder_remark.p_remark"
          v-if="status != 60">
          <template slot-scope="scope">
            <el-input type="textarea" v-model="scope.row.porder_remark.p_remark" v-if="isAuth(235) && roleStatus == 5"
              @blur="updateRemark(scope.row, scope.row.porder_remark.p_remark, 'p_remark')">
            </el-input>
            <span v-else>
              {{ scope.row.porder_remark.p_remark }}
            </span>
          </template>
        </el-table-column>
        <!--  导出excel-->
        <el-table-column align="center" label="导出excel" width="65">
          <template slot-scope="scope">
            <a :href="baseURL + '/download.porderDetailDownload?porder_sn=' + scope.row.porder_sn" target="_blank"
              rel="noopener noreferrer">
              <i class="el-icon-download" style="font-size: 30px;">
              </i>
            </a>
          </template>
        </el-table-column>
        <!--  附件下载-->
        <el-table-column align="center" :label="$t('message.attachmentDownload')" v-if="status == 50">
          <template slot-scope="scope">
            <p v-for="(item, index) in scope.row.order_file" :key="index" style="text-align: left;">
              <a :href="item.file" target="_blank" rel="noopener noreferrer" class="a-link" style="text-align: left;">{{
                item.name }}</a>
            </p>
          </template>
        </el-table-column>
        <!--  操作-->
        <el-table-column align="center" :label="$t('message.operation')" v-else>
          <template slot-scope="scope">
            <!-- 关联子单号 -->
            <p style="margin-bottom: 10px" v-if="status < 30 || status == '配送单待支付'">
              <el-button size="mini" class="secondary" type="success" @click="associateASuborderNumber(scope.row)"
                v-if="isAuth(224) && !scope.row.p_porder_sn">
                {{ $t("message.associateASuborderNumber") }}
              </el-button>
              <!-- 复制物流号 -->
            </p>
            <p style="margin-bottom: 10px" v-if="status > 30" @click="duplicateLogisticsNumbe(scope.row)">
              <el-button size="mini" class="secondary" type="success">
                {{ $t("message.duplicateLogisticsNumbe") }}
              </el-button>
            </p>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paginationContainer">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
        :page-sizes="[50, 80, 100, 200]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <!-- 合并配送单 -->
    <andSingle v-if="andSingleDialogVisible" :itemData="itemData" />
    <!-- EMS打印 -->
    <div v-show="false">
      <div ref="EMSprintingmark" v-if="logistics == 'EMS' || logistics == 'EMS船便'">
        <EMSprintingmark />
      </div>
    </div>
    <!-- OCS打印 -->
    <div v-show="false">
      <!-- 授权 -->
      <div ref="OCSCustomerShippingmark" v-if="logistics == 'OCS' && is_authorized">
        <OCSCustomerShippingmark />
      </div>
      <!-- 没授权的 -->
      <div ref="OCSCustomerShippingmark" v-if="logistics == 'OCS' && !is_authorized">
        <OCSShippingmark />
      </div>
    </div>
    <!-- TW打印 -->
    <div v-show="false">
      <!-- 授权 -->
      <div ref="TWCustomerShippingmark" v-if="logistics == 'TW船便' &&
        is_authorized
      ">
        <TWCustomerShippingmark />
      </div>
      <!-- 没授权的 -->
      <div ref="TWCustomerShippingmark" v-if="logistics == 'TW船便' &&
        !is_authorized
      ">
        <TWCustomerShippingmarkNormal />
      </div>
    </div>
    <!-- RW船便 -->
    <div v-show="false" v-if="logistics == 'RW船便'">
      <div ref="RWCustomerShippingmark">
        <RWCustomerShippingmark />
      </div>
    </div>
    <!-- Raku_DQ -->
    <div v-show="false" v-if="logistics == 'Raku-DQ'">
      <div ref="Raku_DQShippingmark">
        <Raku_DQShippingmark />
      </div>
    </div>
    <!-- DQ打印 -->
    <div v-show="false">
      <!-- 授权 -->
      <div ref="DQShippingmark" v-if="(logistics == '海源DQ船便' ||
        logistics == 'コンテナ' ||
        logistics == 'お任せ(お勧め)' ||
        logistics == '電子特殊便' ||
        logistics == 'その他' ||
        logistics == 'FBA新幹線' || logistics == '海源TK船便' || logistics == '海源電子特殊航空便' || logistics == 'Rロジ専用船便') &&
        is_authorized
      ">
        <DQCustomerShippingmark />
      </div>
      <!-- 没授权的 -->
      <div ref="DQShippingmark" v-if="(logistics == '海源DQ船便' ||
        logistics == 'コンテナ' ||
        logistics == 'お任せ(お勧め)' ||
        logistics == '電子特殊便' ||
        logistics == 'その他' ||
        logistics == 'FBA新幹線' || logistics == '海源TK船便' || logistics == '海源電子特殊航空便' || logistics == 'Rロジ専用船便') &&
        !is_authorized
      ">
        <DQShippingmark />
      </div>
    </div>
    <!-- KS-JP航空便 KS-JP航空経済便-->
    <div v-show="false">
      <div ref="KS_JPShippingmark"
        v-if="logistics == 'KS-JP航空便' || logistics == 'KS-JP航空経済便' || logistics == 'KS-JP電子特殊便'">
        <!-- v-for="(item, index) in printData" :key="index" :datas="item"  -->
        <KS_JPShippingmark />
      </div>
    </div>
    <!-- ems 发票打印 -->
    <div v-show="false">
      <div ref="EMSinvoice">
        <EMSinvoice :detail="item" v-for="(item, index) in EMSinvoiceList" :key="index" />
      </div>
    </div>
    <!-- 分配 -->
    <el-dialog :title="$t('message.adjustTheOperator')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="400px" center>
      <div class="allot">
        <el-select v-model="allotVal.y_id" class="item" filterable :placeholder="$t('message.adjustBusiness')">
          <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
          </el-option>
        </el-select>
        <el-select v-model="allotVal.p_id" class="item" filterable :placeholder="$t('message.distribution')">
          <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
          </el-option>
        </el-select>
        <el-select v-model="allotVal.fba_user" class="item" filterable placeholder="FBA">
          <el-option v-for="item in j" :key="item.id" :label="item.realname" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <el-button type="primary" @click="allotSave">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 标识贴标 -->
    <addFbaSign ref="addFbaSign" :porderSnSet="porderSnSet" />
    <!-- 配送单-配送标 -->
    <shippingLabel ref="shippingLabel" :porder_sn="porder_sn" />
    <!-- STOCKCREW配送单-外部商品标下载 -->
    <outerLabelDownload ref="outerLabelDownload" />
    <!-- 重新生成纳品计划 -->
    <inboundPlanRese ref="inboundPlanRese" :porder_sn="porder_sn" />
    <!-- 删除订单 -->
    <deletePorder ref="deletePorder" :porder_sn="porder_sn" />
  </div>
</template>

<script>
import andSingle from "../components/andSingle";
import { mapState } from "vuex";
import { invoiceStatus, shippingMarkStatus, vipList, authorized } from "@/utlis/options";
import EMSprintingmark from "@/components/Printedsheet/EMSprintingmark";
import TWCustomerShippingmark from "@/components/Printedsheet/TWCustomerShippingmark";
import TWCustomerShippingmarkNormal from "@/components/Printedsheet/TWCustomerShippingmarkNormal";
import RWCustomerShippingmark from "@/components/Printedsheet/RWCustomerShippingmark";
import OCSCustomerShippingmark from "@/components/Printedsheet/OCSCustomerShippingmark";
import OCSShippingmark from "@/components/Printedsheet/OCSShippingmark";
import DQShippingmark from "@/components/Printedsheet/DQShippingmark";
import DQCustomerShippingmark from "@/components/Printedsheet/DQCustomerShippingmark";
import Raku_DQShippingmark from "@/components/Printedsheet/Raku-DQShippingmark";
import KS_JPShippingmark from "@/components/Printedsheet/KS_JPShippingmark.vue";
import EMSinvoice from "@/components/Printedsheet/expressSinglePrint/EMSinvoice"
import addFbaSign from '../components/addFbaSign'
import statistics from '../components/statistics'
import shippingLabel from '../components/shippingLabel'
import outerLabelDownload from '../components/outerLabelDownload'
import inboundPlanRese from '../components/inboundPlanRese'
import deletePorder from '../components/deletePorder'
import { timeDifference } from '@/utlis/date'
export default {
  props: ["status"],
  components: {
    andSingle,
    EMSprintingmark,
    TWCustomerShippingmark,
    TWCustomerShippingmarkNormal,
    RWCustomerShippingmark,
    OCSCustomerShippingmark,
    OCSShippingmark,
    DQShippingmark,
    DQCustomerShippingmark,
    KS_JPShippingmark,
    EMSinvoice,
    Raku_DQShippingmark,
    statistics,
    addFbaSign,
    shippingLabel,
    outerLabelDownload,
    inboundPlanRese,
    deletePorder,
  },
  data() {
    return {
      invoiceStatus,
      shippingMarkStatus,
      authorized,
      vipList,
      tabs: [{ num: 0 }, { num: 0 }, { num: 0 },],
      isMaxHeight: true,
      datas: {
        order_sn: "",
        porder_sn: "",
        dateStart: "",
        dateEnd: "",
        user_id: "",
        status: "",
        org_id: "",
        work_group: "",
        admin_id: "",
        page: 1,
        pageSize: 50,
        filter_fba: "",
        filter_invoice: "",
        filter_maitou_print: "",
        overdue: '',
        express_no: '',
      },
      orderPaymentList: [],
      orderStatusList: [],
      adminOrganization: [],
      total: 0,
      tableData: [],
      selectList: [],
      show: false,
      checked: false,
      roleStatus: localStorage.getItem("japanUserRoleStatus"), //工种
      userList: [],
      //  配送单合并
      andSingleDialogVisible: false,
      itemData: {},
      findBOrderData: {},//千速物流信息
      activities: [],//国际物流
      is_authorized: false, // 是否授权
      EMSinvoiceList: [],// 打印EMS发票
      // 分配数据
      dialogVisibleTitle: "",
      allotVal: {
        y_id: '',
        p_id: '',
        fba_user: '',
      },
      dialogVisible: false,
      allotOptions: [],
      isPint: true,//打印截流
      porderSnSet: [],// 选择中配送单号
      porder_sn: '',//单个 配送单号

    };
  },

  computed: {
    ...mapState({
      logisticsList: (state) => state.porderDetail.logisticsList,
      logistics: (state) => state.porderDetail.logistics, //要打印的物流方式
    }),
    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    j() {
      return this.$store.state.authWorkGroupAdmin.j;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },
  },
  created() {
    let queryData = this.$route.query
    if (queryData.overdue) {
      this.datas.filter_fba = 'overdue'
    }
    if (queryData.express_no) {
      this.datas.express_no = queryData.express_no
    }
    if (queryData.filter_maitou_print) {
      this.datas.filter_maitou_print = queryData.filter_maitou_print
    }
    if (queryData.filter_invoice) {
      this.datas.filter_invoice = queryData.filter_invoice
    }
    if (queryData.user_id) {
      this.datas.user_id = queryData.user_id
    }
    this.generalList();
    this.porderNum();
    this.$store.dispatch("getLogisticsList");
    // this.$api.roleApi.getAdminOrganization().then((res) => {
    //   this.adminOrganization = res.data;
    //   console.log(res);
    // });
  },
  methods: {
    generalList() {
      this.show = false;
      this.datas.status = this.status;
      if (this.datas.filter_fba == 'overdue') {
        this.datas.overdue = '1'
      } else {
        this.datas.overdue = ''
      }
      this.$api.porderApi.generalList(this.datas).then((res) => {
        res.data.data.forEach((list) => {
          list.checked = false
          if (list.porder_remark == null) {
            list.porder_remark = {}
          }
          // 数组去重
          var hash = {};
          list.porder_detail = list.porder_detail.reduce(function (item, next) {
            hash[next.order_sn]
              ? ""
              : (hash[next.order_sn] = true && item.push(next));

            return item;
          }, []);
        });
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.show = true;
      });
    },
    // 标记颜色
    tableRowClassName({ row, rowIndex }) {
      const isMoreThan3Days = (date) => {
        const diff = Math.abs(new Date() - new Date(date));
        return diff > 259200000; // 3天的毫秒数
      };
      if (this.status == 21 && row.is_fba && isMoreThan3Days(row.porder_time_node.datetime_translate)) {
        return 'Danger';
      }
      // console.log(row);
      return '';
    },
    // 搜索
    search() {
      if (this.datas.filter_fba == 3) {
        this.datas.node = '90day'
      } else {
        this.datas.node = ''
      }
      this.datas.page = 1;
      this.generalList();
    },
    // 重置
    reset() {
      this.datas = {
        order_sn: "",
        dateStart: "",
        dateEnd: "",
        user_id: "",
        status: "",
        org_id: "",
        work_group: "",
        admin_id: "",
        page: 1,
        pageSize: 50,
        filter_invoice: "",
        filter_maitou_print: "",
        express_no: '',
        attribute: '',
        authorized: '',
        filter_created_by_type: '',
      };
      this.$refs.cascader.orgId = [];
      this.generalList();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.generalList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.generalList();
    },
    // 整个框选择
    labelSelection(row, column) {
      if (column.className == "el-table-column--selection") {
        this.$refs.multipleTable.toggleRowSelection(row);
      }
    },
    handleSelectionChange(val) {
      this.selectList = val;
    },

    // 编辑备注
    updateRemark(row, value, col) {
      let datas = {
        col,
        porder_sn: row.porder_sn,
        value,
      }
      this.$api.porderApi.updateRemark(datas).then((res) => {
        if (res.code != 0) return this.$message.error(res.message);

      });
    },
    // 人员范围
    setUserList(data) {
      this.userList = data.userList;
      this.datas.org_id = data.id;
      this.datas.admin_id = "";
    },
    //关联子单号
    associateASuborderNumber(item) {
      if (item.p_porder_sn) return this.$message.error('子单号不能关联子单号')
      this.itemData = JSON.parse(JSON.stringify(item));
      this.andSingleDialogVisible = true;
    },
    //配送单-FBA-添加 删除标识
    addFbaSign() {
      this.porderSnSet = []
      if (this.selectList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.selectList.forEach((item) => {
        this.porderSnSet.push(item.porder_sn);
      });
      this.$refs.addFbaSign.dialogVisible = true
      this.$refs.addFbaSign.typeSet = []
      this.$refs.addFbaSign.type = '1'

    },

    // 配送单合并
    isPorderAddressSame() {
      if (this.selectList.length < 2)
        return this.$message.error(this.$t("message.porderLengthPrompt"));
      let datas = {
        porder_sn_set: [],
      };
      this.selectList.forEach((item) => {
        datas.porder_sn_set.push(item.porder_sn);
      });
      // 比对多个配送单收件地址是否完全一致
      this.$api.porderApi.isPorderAddressSame(datas).then((res) => {
        if (!res.data) {
          this.$confirm(
            `当前要合并的配送单， <b  style='font-size:20px;color:#c35257'>地址不一样</b>，请特别注意，配送单合并后，原有配送单将进行删除，地址将只保留一个配送单的`,
            this.$t("message.hint"),
            {
              confirmButtonText: this.$t("message.ok"), //确定
              cancelButtonText: this.$t("message.cancel"), //取消
              type: "warning",
              center: true,
              dangerouslyUseHTMLString: true
            }
          )
            .then(() => {
              this.mergePorder()

            })
            .catch(() => { });
        } else {
          this.mergePorder()
        }
      });
    },
    // 配送单合并
    mergePorder() {
      if (this.selectList.length < 2)
        return this.$message.error(this.$t("message.porderLengthPrompt"));
      let datas = {
        porderSnSet: [],
      };
      this.selectList.forEach((item) => {
        datas.porderSnSet.push(item.porder_sn);
      });
      this.$confirm(
        this.$t("message.consolidationOfDistributionOrderPrompt"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          // 合单
          this.$api.porderApi.mergePorder(datas).then((res) => {
            this.$message.success(res.msg);
            this.generalList();
          });
        })
        .catch(() => { });
    },
    // 物流方式转换
    logisticsName(id) {
      let name;
      this.logisticsList.forEach((item) => {
        if (item.id == id) {
          name = item.name;
        }
      });
      return name;
    },
    //配送单数量统计
    porderNum() {
      if (this.status == 20) {
        this.$api.tabTotalApi.porderTranslateNum().then(res => {
          this.tabs = res.data
        })
      }
      else if (this.status == 21) {
        this.$api.tabTotalApi.porderPackNum().then(res => {
          this.tabs = res.data
        })
      }
      else if (this.status == 22) {
        this.$api.tabTotalApi.porderOfferNum().then(res => {
          this.tabs = res.data
        })
      }
      else if (this.status == '配送单待支付') {
        this.$api.tabTotalApi.porderWaitPayNum().then(res => {
          this.tabs = res.data
        })
      }
      else if (this.status == 50) {
        this.$api.tabTotalApi.porderWaitDeliveryNum().then(res => {
          this.tabs = res.data
        })
      }
      else if (this.status == 60) {
        this.$api.tabTotalApi.porderDeliveryNum().then(res => {
          this.tabs = res.data
        })
      }

    },
    //复制物流号
    duplicateLogisticsNumbe(item) {
      if (item.express_invoice == false) return this.$message.error('暂无物流号')
      let copyUrl = `配送单：${item.porder_sn}`
      item.express_invoice.forEach(express => {
        copyUrl += `\n${express.express_no}`
      })
      this.copy(copyUrl)
    },
    // 跳转物流
    lookExpress(item) {
      let datas = {
        express_no: item.express_no
      }
      this.activities = []
      this.$api.logisticsTrack(datas).then(res => {
        if (res.data != false) {
          res.data.address_data[0].color = '#B4272D'
          this.activities = res.data.address_data
        } else { // 没有物流信息的还是跳转物流官网
          let routeUrl = item.logistics_search_rule.href
          if (item.logistics_search_rule.data != false) {
            routeUrl += '?'
            for (let key in item.logistics_search_rule.data) {
              routeUrl += key + '=' + item.logistics_search_rule.data[key] + '&'
            }
          }
          window.open(routeUrl, "_blank");
        }
      })
    },
    //千速
    findBOrder(item) {
      let datas = {
        orderNo: item.express_no,
      }
      this.findBOrderData = {}
      this.$api.porderApi.findBOrder(datas).then(res => {
        this.findBOrderData = res.data
      })
    },
    //打印
    pint(express_no, logistics, id, i) {
      if (!this.isPint) return this.$message.error('正在生成唛头，请勿频繁操作')
      this.isPint = false
      if (logistics == 'KS-JP航空便' || logistics == 'KS-JP航空経済便' || logistics == 'KS-JP電子特殊便') {
        this.$api.porderApi.kilospeedMark({ express_no, freightIds: '' }).then(res => {
          res.data.forEach((item, index) => {
            item.num = index + 1
            item.show = false
            item.logistics = logistics
          })
          // 排序
          res.data.sort(function (a, b) {
            return a.number_by_express_no - b.number_by_express_no;
          });
          let datas = {
            logistics,
            printData: res.data,
            is_authorized: res.data[0].is_authorized
          }
          this.is_authorized = res.data[0].is_authorized
          this.$store.commit('setPrintData', datas)
          setTimeout(() => {
            this.$print(this.$refs.KS_JPShippingmark);
            this.$store.commit('setPrintData', {})
            this.isPint = true
            this.tableData.find(item => item.id == id).express_invoice[i].maitou_print_at = '已打印'
          }, 1000)
          // this.$nextTick(() => {
          //   this.$print(this.$refs.KS_JPShippingmark);
          //   this.$store.commit('setPrintData', {})
          // });
        })
      } else {
        this.$api.getMaitouData({ express_no, freightIds: '' }).then(res => {
          res.data.forEach((item, index) => {
            item.num = index + 1
          })
          // 排序
          res.data.sort(function (a, b) {
            return a.number_by_express_no - b.number_by_express_no;
          });
          let datas = {
            logistics,
            printData: res.data,
            is_authorized: res.data[0].is_authorized
          }
          this.is_authorized = res.data[0].is_authorized
          this.$store.commit('setPrintData', datas)
          if (logistics == 'EMS' || logistics == 'EMS船便') {
            this.$nextTick(() => {
              this.$print(this.$refs.EMSprintingmark);
              this.$store.commit('setPrintData', {})
              this.tableData.find(item => item.id == id).express_invoice[i].maitou_print_at = '已打印'

              this.$forceUpdate()
              this.isPint = true
            });
          } else if (logistics == 'TW船便') {
            this.$nextTick(() => {
              this.$print(this.$refs.TWCustomerShippingmark);
              this.$store.commit('setPrintData', {})
              this.tableData.find(item => item.id == id).express_invoice[i].maitou_print_at = '已打印'
              this.$forceUpdate()
              this.isPint = true
            });
          } else if (logistics == 'RW船便') {
            this.$nextTick(() => {
              this.$print(this.$refs.RWCustomerShippingmark);
              this.$store.commit('setPrintData', {})
              this.tableData.find(item => item.id == id).express_invoice[i].maitou_print_at = '已打印'
              this.$forceUpdate()
              this.isPint = true
            });
          }
          else if (logistics == 'Raku-DQ') {
            this.$nextTick(() => {
              this.$print(this.$refs.Raku_DQShippingmark);
              this.$store.commit('setPrintData', {})
              this.tableData.find(item => item.id == id).express_invoice[i].maitou_print_at = '已打印'
              this.$forceUpdate()
              this.isPint = true
            });
          }
          else if (logistics == 'OCS') {
            this.$nextTick(() => {
              this.$print(this.$refs.OCSCustomerShippingmark);
              this.$store.commit('setPrintData', {})
              this.tableData.find(item => item.id == id).express_invoice[i].maitou_print_at = '已打印'
              this.$forceUpdate()
              this.isPint = true
            });
          } else {
            this.$nextTick(() => {
              this.$print(this.$refs.DQShippingmark);
              this.$store.commit('setPrintData', {})
              this.tableData.find(item => item.id == id).express_invoice[i].maitou_print_at = '已打印'
              this.$forceUpdate()
              this.isPint = true
            });
          }
        })
      }
      setTimeout(() => {
        this.isPint = true
      }, 3000)
    },
    // 批量打印EMS发票
    batchPint() {
      this.EMSinvoiceList = []
      var list = []
      let i = 0 // 是否全部加载完毕
      this.selectList.forEach(item => {
        item.express_invoice.forEach(items => {
          console.log(items);
          if (items.logistics_id == 3 || items.logistics_id == 1) {
            i++
            if (items.invoiceStatus == '未保存' || items.invoiceStatus == '临时保存') {
              list.push(items)
            }
          }
        })
      })
      if (i == 0) return this.$message.error('未选择EMS物流单号')
      // console.log(list);
      if (list != false) {
        let str = ''
        list.forEach(item => {
          str += `<p>物流单号：${item.express_no}</p>`
        })
        str += '发票没进行保存，无法打印发票'
        this.$alert(str, '发票未保存', {
          dangerouslyUseHTMLString: true
        });
        return false
      }
      let express_no_set = [] //记录已打印
      this.selectList.forEach(item => {

        item.express_invoice.forEach(items => {
          if (items.logistics_id == 3 || items.logistics_id == 1) {
            let datas = {
              express_no: items.express_no,
            };
            express_no_set.push(items.express_no)
            this.$api.invoiceApi.editPreview(datas).then((res) => {
              if (res.data.importer == null) {
                res.data.importer = {}
              }
              this.EMSinvoiceList.push(res.data)
              if (this.EMSinvoiceList.length == i) {
                this.$api.invoiceApi.invoicePrintTimes({ express_no_set }).then(res => {
                  this.generalList();
                }) //记录已打印
                this.$nextTick(() => {
                  this.$print(this.$refs.EMSinvoice);

                })
              }

            });
          }
        })
      })
    },
    // 单个打印EMS发票
    pintEMSinvoice(item, rowIndex, index) {
      console.log(rowIndex, index);

      this.EMSinvoiceList = []
      let str = ''
      if (item.invoiceStatus == '未保存' || item.invoiceStatus == '临时保存') {
        str = `<p>物流单号：${item.express_no}</p>发票没进行保存，无法打印发票`
      }
      if (str) {
        this.$alert(str, '发票未保存', {
          dangerouslyUseHTMLString: true
        });
        return false
      }


      this.$api.invoiceApi.editPreview({ express_no: item.express_no }).then((res) => {
        if (res.data.importer == null) {
          res.data.importer = {}
        }
        this.EMSinvoiceList.push(res.data)
        //记录已打印
        this.$api.invoiceApi.invoicePrintTimes({ express_no_set: [item.express_no] }).then(() => {
          this.tableData[rowIndex].express_invoice[index].invoice_print_times += 1
          this.$forceUpdate()
        })
        this.$nextTick(() => {
          this.$print(this.$refs.EMSinvoice);
        })
      });
    },
    // 批量打印唛头
    allPint() {
      let printData = []
      let express_noList = []
      let logistics = ''
      this.selectList.forEach(item => {
        item.express_invoice.forEach(items => {
          if (items.logistics_id == this.datas.logistics_id) {
            express_noList.push(items.express_no)
            logistics = items.logistics_name

          }
        })
      })
      if (express_noList == false) return this.$message.error('未选择物流单号')

      if (logistics == 'KS-JP航空便' || logistics == 'KS-JP航空経済便' || logistics == 'KS-JP電子特殊便') {
        let index = 0
        express_noList.forEach((express_no) => {
          this.$api.porderApi.kilospeedMark({ express_no, freightIds: '' }).then(res => {
            res.data.forEach((item, index) => {
              item.num = index + 1
              item.show = false
              item.logistics = logistics
            })
            // 排序
            res.data.sort(function (a, b) {
              return a.number_by_express_no - b.number_by_express_no;
            });
            printData = [...printData, ...res.data]
            index++
            if (express_noList.length == index) {
              let datas = {
                logistics,
                printData,
                is_authorized: res.data[0].is_authorized
              }
              this.is_authorized = res.data[0].is_authorized
              this.$store.commit('setPrintData', datas)
              setTimeout(() => {
                this.$print(this.$refs.KS_JPShippingmark);
                this.$store.commit('setPrintData', {})
              }, 1000)
            }
          })
        })
      } else {
        let index = 0
        express_noList.forEach((express_no) => {
          this.$api.getMaitouData({ express_no, freightIds: '' }).then(res => {
            res.data.forEach((item, i) => {
              item.num = i + 1
            })
            // 排序
            res.data.sort(function (a, b) {
              return a.number_by_express_no - b.number_by_express_no;
            });
            printData = [...printData, ...res.data]
            index++
            if (express_noList.length == index) {
              let datas = {
                logistics,
                printData,
                is_authorized: res.data[0].is_authorized
              }
              this.is_authorized = res.data[0].is_authorized
              this.$store.commit('setPrintData', datas)
              if (logistics == 'EMS' || logistics == 'EMS船便') {
                this.$nextTick(() => {
                  this.$print(this.$refs.EMSprintingmark);
                  this.$store.commit('setPrintData', {})
                  this.$forceUpdate()
                });
              } else if (logistics == 'TW船便') {
                this.$nextTick(() => {
                  this.$print(this.$refs.TWCustomerShippingmark);
                  this.$store.commit('setPrintData', {})
                  this.$forceUpdate()
                });
              } else if (logistics == 'RW船便') {
                this.$nextTick(() => {
                  this.$print(this.$refs.RWCustomerShippingmark);
                  this.$store.commit('setPrintData', {})
                  this.$forceUpdate()
                });
              } else if (logistics == 'Raku-DQ') {
                this.$nextTick(() => {
                  this.$print(this.$refs.Raku_DQShippingmark);
                  this.$store.commit('setPrintData', {})
                  this.$forceUpdate()
                });
              } else if (logistics == 'OCS') {
                this.$nextTick(() => {
                  this.$print(this.$refs.OCSCustomerShippingmark);
                  this.$store.commit('setPrintData', {})
                  this.$forceUpdate()
                });

              } else {
                this.$nextTick(() => {
                  this.$print(this.$refs.DQShippingmark);
                  this.$store.commit('setPrintData', {})
                  this.$forceUpdate()
                });
              }
              this.generalList();
            }
          })
        })

      }
    },
    //显示分配弹框
    allot() {
      if (this.selectList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      if (this.selectList.length == 1) {
        this.allotVal.y_id = this.selectList[0].y_admin ? this.selectList[0].y_admin.id : ''
        this.allotVal.p_id = this.selectList[0].p_admin ? this.selectList[0].p_admin.id : ''
        this.allotVal.fba_user = this.selectList[0].fba_admin ? this.selectList[0].fba_admin.id : ''
      } else {
        this.allotVal.y_id = ''
        this.allotVal.p_id = ''
        this.allotVal.fba_user = ''
      }
      this.dialogVisible = true;
    },
    // 分配
    allotSave() {
      let datas = {
        porder_sn_set: [],
        y_id: this.allotVal.y_id,
        p_id: this.allotVal.p_id,
        fba_user: this.allotVal.fba_user,
      };
      this.selectList.forEach((item) => {
        datas.porder_sn_set.push(item.porder_sn);
      });
      this.$api.porderApi.allotYGP(datas).then((res) => {
        if (res.code != 0) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.generalList();
      });

    },
    //全选
    allChecked() {
      this.tableData.forEach(item => {
        item.checked = this.checked
      })
      this.handleSelectionChange()
    },
    handleSelectionChange() {
      this.selectList = []
      this.tableData.forEach(item => {
        if (item.checked) {
          this.selectList.push(item)
        }
      })
      this.checked = this.tableData.every(item => item.checked)
      this.$forceUpdate()
    },
    // 点击下载配送标：
    // FBA配送标生成依赖后台装箱信息上传，确认入金后的前10分钟内可能还未同步完成。
    // 因此先校验确认入金时间，未到可下载时间时只做业务提醒，不打开下载弹窗。
    handleClick(row) {
      const confirmTime = row.porder_time_node ? row.porder_time_node.datetime_pay_confirm : ''
      if (this.isWithinDepositConfirmLimit(confirmTime)) {
        return this.$message.warning(`装箱信息上传中，请于【${this.getDownloadAvailableTime(confirmTime)}】后再操作下载。`)
      }
      this.porder_sn = row.porder_sn
      this.$refs.shippingLabel.dialogVisible = true
    },
    // 打开STOCKCREW商品标规格选择弹窗。
    openOuterLabelDownload(porderSn) {
      this.$refs.outerLabelDownload.open(porderSn)
    },
    // 判断当前时间是否仍处于配送标下载限制期。
    // confirmTime: 确认入金时间，格式通常为 yyyy-MM-dd HH:mm:ss。
    // 规则：当前时间 < 确认入金时间 + 10分钟 时，返回 true，表示禁止下载。
    // 时间为空或无法解析时不拦截，避免脏数据导致业务完全无法操作。
    isWithinDepositConfirmLimit(confirmTime) {
      if (!confirmTime) return false
      const confirmDate = this.parseDate(confirmTime)
      if (!confirmDate) return false
      return new Date().getTime() < confirmDate.getTime() + 10 * 60 * 1000
    },
    // 获取提示文案中的“可下载时间”。
    // 即确认入金时间向后顺延10分钟，格式化后放入：
    // 装箱信息上传中，请于【可下载时间】后再操作下载。
    getDownloadAvailableTime(confirmTime) {
      const confirmDate = this.parseDate(confirmTime)
      if (!confirmDate) return confirmTime
      return this.formatDate(new Date(confirmDate.getTime() + 10 * 60 * 1000))
    },
    // 兼容后端返回的 yyyy-MM-dd HH:mm:ss 字符串。
    // Safari/部分浏览器对横杠日期解析不稳定，所以统一把 '-' 替换成 '/' 再创建 Date。
    // 解析失败时返回 null，由调用方决定是否拦截。
    parseDate(date) {
      const parsedDate = new Date(String(date).replace(/-/g, '/'))
      return isNaN(parsedDate.getTime()) ? null : parsedDate
    },
    // 将 Date 对象格式化为 yyyy-MM-dd HH:mm:ss，用于提示用户具体可下载时间。
    formatDate(date) {
      const pad = (num) => num < 10 ? `0${num}` : num
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    },
    // 点击重新生成纳品计划
    reGenerateInboundPlan(porder_sn) {
      this.porder_sn = porder_sn
      this.$refs.inboundPlanRese.dialogVisible = true
    },
    // 点击删除订单
    deliveryOrderDeletion() {
      if (this.selectList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      if (this.selectList.length > 1)
        return this.$message.error('只能单个删除配送单');

      this.$refs.deletePorder.delData = {
        delete_reason: '',
        porder_sn: this.selectList[0].porder_sn,
      }
      this.$refs.deletePorder.dialogVisible = true
    },
  },
};
</script>

<style lang='scss' scoped>
.search {
  position: relative;

  /deep/.el-select {
    width: 200px;
  }

  /deep/.el-date-editor {
    width: 200px !important;
  }

  /deep/.el-input__inner {
    width: 200px;
  }
}

.tableList {
  margin: 20px 0;

  /deep/.el-button {
    width: 92px;
    padding: 8px 0;
  }

  .name {
    font-size: 20px;
    color: #b4272d;
  }
}

.table {
  ul {
    border: 1px solid #edeff4;
    border-top: 0;
    padding: 0;

    &:nth-child(1) {
      border-top: 1px solid #edeff4;
    }

    li {
      border-right: 1px solid #edeff4;
      padding: 10px 0;
      flex: 1;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex2 {
      flex: 2;
      position: relative;

      .timeout {
        position: absolute;
        left: 0;
        top: 0px;
        padding: 0px 8px;
        border-radius: 6px;
        color: #fff;
        background-color: #b4272d;
        font-size: 12px
      }
    }
  }
}

.item {
  margin-right: 20px;
  margin-bottom: 20px;
}

.operationContainer {
  display: flex;
  margin-bottom: 0;

  .leftContainer {
    flex: 7;
    display: flex;
    flex-wrap: wrap;
  }
}

.btn {
  text-align: right
}

.oneself {
  position: relative;

  .discard {
    // position: absolute;
    // top: 0;
    // right: 2px;
    display: inline-block;
    background-color: #b4272d;
    width: 20px;
    height: 20px;
    line-height: 20px;
    border-radius: 50%;
    text-align: center;
    color: #fff;
  }
}

/deep/.cell {
  padding: 0 3px !important;
}

/deep/.el-checkbox {
  line-height: 40px;
  min-height: 40px;
  min-width: 40px;
}

.content {
  padding: 0 20px;

  /deep/.el-textarea__inner {
    height: 100px;
  }

  /deep/.el-radio {
    margin-bottom: 20px;
  }
}

.template {
  text-align: left;
}

a {
  color: #b4272d;

  &:hover {
    text-decoration: underline;
  }
}

.is_fba {
  font-size: 20px;
  color: #67C23A;
  font-weight: bold;
}

.stockcrew-logo {
  display: block;
  width: 66px;
  height: auto;
  margin: 6px auto 0;
}

/deep/ .el-textarea__inner {
  padding: 3px;
  min-height: 100px !important;

}

.allot {
  padding: 0 30px;

  /deep/.el-select {
    width: 100%;
  }
}

.orderList {
  overflow-y: auto;
}

/deep/.Danger {
  background-color: rgba(242, 210, 235, 0.5) !important;
}

/deep/.el-table tbody .Danger:hover>td {
  background-color: rgba(242, 210, 235, 0.5) !important;
}

.downGoodsLabels {
  display: flex;
  justify-content: space-between;

  i {
    cursor: pointer;
    font-size: 25px;
    color: #b4272d;
  }
}

.is_from_direct_box {
  margin: 0 auto 10px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  border: 1px solid #b4272d;
  color: #b4272d;
  text-align: center;
  line-height: 30px;
  font-size: 16px;
}
</style>
